import React, { useCallback, useState } from "react"
import "./radio-input.css"
import { useTranslation } from "@nova/use-translation"
import { ButtonRadioInput } from "@nova/component-btn"
import classNames from "classnames"

type RadioInputProps = {
    value?: string
    options: { value: string; label: string }[]
    className?: string
    disabled?: boolean
    onChange: (checked: string) => void
}
export const RadioInput = ({ value, options, className, disabled, onChange }: RadioInputProps) => {
    const [selected, setSelected] = useState(value)
    const { t } = useTranslation()

    const handleRadioClick = useCallback(
        (newSelected: string) => {
            setSelected(newSelected)
            onChange(newSelected)
        },
        [onChange]
    )
    return (
        <div role="radiogroup" className="flex flex-col gap-3">
            {options.map((option, idx) => {
                const checked = selected === option.value
                return (
                    <div key={idx} className="radio-input flex gap-2">
                        <ButtonRadioInput
                            id={option.label}
                            className={className}
                            onClick={() => handleRadioClick(option.value)}
                            checked={checked}
                            disabled={disabled}
                            data-testid={`radio-input-${idx}`}
                        />
                        <label
                            htmlFor={option.label}
                            className={classNames("radio-input__label", {
                                "radio-input__label--disabled": disabled,
                            })}
                        >
                            {t(option.label)}
                        </label>
                    </div>
                )
            })}
        </div>
    )
}
